"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDynamicColumnsToFilterGroups = exports.formatDynamicColumnValue = exports.useDynamicColumnDefinitions = void 0;
const DynamicColumnConfigProvider_1 = __importDefault(require("../../../ui/features/dynamic-columns/components/DynamicColumnConfigProvider"));
const hooks_1 = require("../../../ui/hooks");
const material_1 = require("@mui/material");
const react_1 = __importStar(require("react"));
const immutable_1 = __importDefault(require("swr/immutable"));
function useDynamicColumnDefinitions(entity, enabled) {
    const dynamicColumnContext = (0, react_1.useContext)(DynamicColumnConfigProvider_1.default);
    const dynamicColumnClient = (0, hooks_1.useDynamicColumnClient)();
    // we use two different swr paths, one for enabled other for disabled dynamic columns
    // this is needed because there might be different instances of tables for same entity, and we need to return properly cached data depending on enabled flag
    return (0, immutable_1.default)(`entityTable/${entity}/dynamicColumns/${enabled}`, () => __awaiter(this, void 0, void 0, function* () {
        if (!enabled) {
            return {
                columnDefs: [],
                handlerMap: new Map(),
            };
        }
        const handlerMap = new Map();
        const columnDefs = yield dynamicColumnClient.listColumns({
            entity: entity,
            status: 'active',
        });
        const promises = dynamicColumnContext.columnHandlers
            .filter((handler) => columnDefs.rows.some((col) => { var _a; return handler.name === ((_a = col.metadata) === null || _a === void 0 ? void 0 : _a.columnHandlerName); }))
            .map((handler) => {
            if (handler) {
                if (handler.loadData) {
                    return handler.loadData().then((data) => {
                        handlerMap.set(handler.name, { handler: handler, data: data });
                    });
                }
                else {
                    handlerMap.set(handler.name, { handler: handler, data: undefined });
                }
            }
            return Promise.resolve();
        });
        yield Promise.all(promises);
        return {
            columnDefs: columnDefs.rows,
            handlerMap: handlerMap,
        };
    }));
}
exports.useDynamicColumnDefinitions = useDynamicColumnDefinitions;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function formatDynamicColumnValue(row, columnDef, handler) {
    var _a, _b;
    let formattedValue = row.columns[`_dynamic_${columnDef.name}`];
    if (columnDef.type.endsWith('-array') && (handler === null || handler === void 0 ? void 0 : handler.handler.formatArray)) {
        formattedValue = handler.handler.formatArray(row.columns[`_dynamic_${columnDef.name}`], (_a = handler.data) !== null && _a !== void 0 ? _a : new Map());
    }
    else if (handler === null || handler === void 0 ? void 0 : handler.handler.format) {
        formattedValue = handler.handler.format(row.columns[`_dynamic_${columnDef.name}`], (_b = handler.data) !== null && _b !== void 0 ? _b : new Map());
    }
    if (typeof formattedValue === 'string') {
        return (react_1.default.createElement(material_1.Typography, { style: { wordWrap: 'break-word' }, component: 'span' }, formattedValue));
    }
    else {
        return formattedValue;
    }
}
exports.formatDynamicColumnValue = formatDynamicColumnValue;
function mapDynamicColumnsToFilterGroups(columnData, initialValues) {
    const filterGroups = [];
    if (columnData) {
        const filterDynamicColumns = columnData.columnDefs.filter((column) => { var _a; return (_a = column.metadata) === null || _a === void 0 ? void 0 : _a.showInFilters; });
        for (const column of filterDynamicColumns) {
            const initialValue = initialValues ? getInitialValue(initialValues, column.name) : undefined;
            filterGroups.push(mapDynamicColumnToFilterGroup(column, columnData.handlerMap, initialValue));
        }
    }
    return filterGroups;
}
exports.mapDynamicColumnsToFilterGroups = mapDynamicColumnsToFilterGroups;
function getInitialValue(initialValues, columnName) {
    const values = [];
    flatten(initialValues).forEach((filter) => {
        if ('column' in filter && `_dynamic_${columnName}` === filter.column && 'value' in filter && filter.value) {
            values.push(filter.value);
        }
    });
    return values;
}
function flatten(filter) {
    const flatFilter = [];
    filter.forEach((f) => {
        if ('filter' in f && f.op !== 'relation') {
            flatFilter.push(...flatten(f.filter));
        }
        else {
            flatFilter.push(f);
        }
    });
    return flatFilter;
}
function mapDynamicColumnToFilterGroup(dynamicColumn, dynamicColumnHandlers, initialValues) {
    var _a, _b, _c, _d, _e;
    const columnLabel = (_b = (_a = dynamicColumn.metadata) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : '';
    const columnName = `_dynamic_${dynamicColumn.name}`;
    const columnType = dynamicColumn.type;
    const filterData = mapHandlerToSelectItems(dynamicColumn, dynamicColumnHandlers.get((_d = (_c = dynamicColumn.metadata) === null || _c === void 0 ? void 0 : _c.columnHandlerName) !== null && _d !== void 0 ? _d : ''));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const initialValue = initialValues && initialValues.length > 0 ? initialValues[0] : undefined;
    switch (columnType) {
        case 'string':
            if (filterData) {
                return {
                    label: columnLabel,
                    configs: [
                        {
                            type: 'select-many',
                            field: columnName,
                            items: filterData,
                            initialValue: initialValue,
                            op: 'in',
                        },
                    ],
                };
            }
            return {
                label: columnLabel,
                configs: [
                    {
                        type: 'string',
                        field: columnName,
                        label: columnLabel,
                        initialValue: initialValue,
                    },
                ],
            };
        case 'string-array':
            if (filterData) {
                return {
                    label: columnLabel,
                    configs: [
                        {
                            type: 'select-many',
                            field: columnName,
                            items: filterData,
                            op: 'overlap',
                            initialValue: initialValue,
                        },
                    ],
                };
            }
            return {
                label: columnLabel,
                configs: [
                    {
                        type: 'string',
                        field: columnName,
                        label: columnLabel,
                        mapToFilter: (filter) => {
                            const stringFilter = filter.find((f) => f.field === columnName);
                            let stringFilterValue = stringFilter === null || stringFilter === void 0 ? void 0 : stringFilter.value;
                            if (stringFilterValue && Array.isArray(stringFilterValue) && stringFilterValue.length) {
                                stringFilterValue = stringFilterValue[0];
                            }
                            if (typeof stringFilterValue !== 'string') {
                                return undefined;
                            }
                            return [{ column: columnName, op: 'overlap', value: [stringFilterValue] }];
                        },
                        initialValue: initialValue,
                    },
                ],
            };
        case 'boolean':
            return {
                label: columnLabel,
                configs: [
                    {
                        type: 'custom',
                        field: columnName,
                        component: (props) => (react_1.default.createElement(material_1.FormControlLabel, { sx: { marginTop: -1, marginBottom: -1 }, control: react_1.default.createElement(material_1.Switch, { checked: props.value === true, onChange: (event) => props.onChange(props.config.field, event.target.checked || undefined, undefined, undefined, columnLabel) }), label: undefined })),
                        initialValue: initialValue,
                    },
                ],
            };
        case 'number':
            if ((_e = dynamicColumn.metadata) === null || _e === void 0 ? void 0 : _e.columnHandlerName.toLowerCase().includes('date')) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const initialDateFrom = (initialValues && initialValues.length > 0 && new Date(initialValues[0])) || undefined;
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const initialDateTo = (initialValues && initialValues.length > 1 && new Date(initialValues[1])) || undefined;
                return {
                    label: columnLabel,
                    configs: [
                        {
                            type: 'date-from-to',
                            field: columnName,
                            fromLabel: 'From',
                            toLabel: 'To',
                            showChipLabel: true,
                            mapToFilter: (filter) => {
                                const dateFilter = filter.find((f) => f.field === columnName);
                                if (!(dateFilter === null || dateFilter === void 0 ? void 0 : dateFilter.value)) {
                                    return undefined;
                                }
                                const filterDates = dateFilter.value;
                                const filters = [];
                                if (filterDates.dateFrom) {
                                    filters.push({ column: columnName, op: '>=', value: filterDates.dateFrom.getTime() });
                                }
                                if (filterDates.dateTo) {
                                    filters.push({ column: columnName, op: '<=', value: filterDates.dateTo.getTime() });
                                }
                                if (filters.length) {
                                    return [{ op: 'and', filter: filters }];
                                }
                                return undefined;
                            },
                            initialValue: (initialDateFrom || initialDateTo) && {
                                dateFrom: initialDateFrom,
                                dateTo: initialDateTo,
                            },
                        },
                    ],
                };
            }
            else if (filterData) {
                return {
                    label: columnLabel,
                    configs: [
                        {
                            type: 'select-many',
                            field: columnName,
                            items: filterData,
                            op: 'in',
                            initialValue: initialValue,
                        },
                    ],
                };
            }
            return {
                label: columnLabel,
                configs: [
                    {
                        type: 'number',
                        field: columnName,
                        label: columnLabel,
                        initialValue: initialValue,
                    },
                ],
            };
        case 'number-array':
            if (filterData) {
                return {
                    label: columnLabel,
                    configs: [
                        {
                            type: 'select-many',
                            field: columnName,
                            items: filterData,
                            op: 'overlap',
                            initialValue: initialValue,
                        },
                    ],
                };
            }
            return {
                label: columnLabel,
                configs: [
                    {
                        type: 'number',
                        field: columnName,
                        label: columnLabel,
                        mapToFilter: (filter) => {
                            const numberFilter = filter.find((f) => f.field === columnName);
                            let numberFilterValue = numberFilter === null || numberFilter === void 0 ? void 0 : numberFilter.value;
                            if (numberFilterValue && Array.isArray(numberFilterValue) && numberFilterValue.length) {
                                numberFilterValue = numberFilterValue[0];
                            }
                            if (typeof numberFilterValue !== 'number') {
                                return undefined;
                            }
                            return [{ column: columnName, op: 'overlap', value: [numberFilterValue] }];
                        },
                        initialValue: initialValue,
                    },
                ],
            };
        case 'full-text-search':
            return {
                label: columnLabel,
                configs: [
                    {
                        type: 'string',
                        field: columnName,
                        label: columnLabel,
                        op: 'full-text-query',
                        initialValue: initialValue,
                    },
                ],
            };
        case 'id':
        case 'id-array':
            return {
                label: columnLabel,
                configs: [
                    {
                        type: 'select-many',
                        field: columnName,
                        items: filterData !== null && filterData !== void 0 ? filterData : [],
                        op: columnType === 'id' ? 'in' : 'overlap',
                        initialValue: initialValue,
                    },
                ],
            };
        default:
            throw Error(`Invalid dynamic column type: ${columnType}`);
    }
}
function mapHandlerToSelectItems(dynamicColumn, columnHandler) {
    if (!(columnHandler === null || columnHandler === void 0 ? void 0 : columnHandler.data)) {
        return undefined;
    }
    const selectItems = [];
    columnHandler.data.forEach((value, key) => {
        selectItems.push({
            label: value,
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            value: key,
        });
    });
    return selectItems;
}
